import Index from '@/pages/folder/Index'
import List from '@/pages/folder/List'
import Create from '@/pages/folder/Create'
import Modify from '@/pages/folder/Modify'
import Photo from '@/pages/folder/Photo'

export default {
  path: 'folder',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create
    },
    {
      path: 'modify/:id',
      component: Modify
    },
    {
      path: ':id',
      component: Photo
    }
  ]
}

